import { Svg } from './svg'

export const ChatIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3064_75365)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3C0 1.34315 1.34315 0 3 0H13C14.6569 0 16 1.34315
      16 3V9C16 10.6569 14.6569 12 13 12H10.3546L4.90994 15.0864C4.08574 15.602 3 15.0118 3 14.0247V12C1.34315
       12 0 10.6569 0 9V3ZM3 2C2.44772 2 2 2.44772 2 3V9C2 9.55229 2.44772 10 3 10H5V12.7364L9.82719 10H13C13.5523
       10 14 9.55228 14 9V3C14 2.44772 13.5523 2 13 2H3Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3064_75365">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </Svg>
)
